import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSelectAllIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 18,
		height: 18,
		x: 3,
		y: 3,
		strokeDasharray: "4 2",
		rx: 2
	}), /* @__PURE__ */ _jsx("rect", {
		width: 12,
		height: 12,
		x: 6,
		y: 6,
		fill: "currentColor",
		stroke: "none",
		opacity: .2,
		rx: 1
	})]
});
export default SvgSelectAllIcon;
